import makeStyles from '@material-ui/styles/makeStyles';

export const useGlobalStyles = makeStyles({
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    fontWeight: 600
  },
  '@keyframes rotate': {
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  menuItemIcon: {
    marginRight: '4px',
    '&.loading': {
      animation: `$rotate 3s linear infinite`,
    },
  },
});
